/**
 * Generates a unique hash code for the given string value.
 *
 * The hash function is adapted from https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0#gistcomment-2800233
 *
 * @param value - (optional) The string to hash
 * @returns The resulting hash code.
 */
export function stringHash(value?: string | null): number {
  if (!value) return 0;

  // eslint-disable-next-line no-bitwise -- `| 0` ensures the result is a 32-bit integer
  const hash = Array.from(value).reduce((s, c) => (Math.imul(31, s) + c.charCodeAt(0)) | 0, 0);

  return Math.abs(hash);
}
